<template>
  <div class="bimg">
   <Row>
   <Col span="24" style="height:700px;">
    <div class="enroll">
      <br>
      <h1 style="color: #426bff">用户登录</h1>
      <br>
      <br>
      <Form>
        <FormItem>
          <Col span="9" offset="2">
           
            <Input v-model="mobile" placeholder="手机号"></Input>
          </Col>
          <Col span="9" offset="2">
            <Input v-model="pwd" placeholder="密码" type="password"></Input>
          </Col>
        </FormItem>
        <FormItem>
          <Col span="6" offset="1">
            <Checkbox v-model="rememberPwd">下次自动登录</Checkbox>
          </Col>
          <Col span="6" offset="11"><router-link to="/password">忘记密码？</router-link></Col>
        </FormItem>
        <FormItem>
          <Col span="6" offset="4">
            <Button type="" style="width:180px;background:#426bff;color:white;font-size:16px" @click="login">登录</Button>
          </Col>
          <Col span="6" offset="3">
            <router-link to="/register"><Button type="" style="width:180px;background:#426bff;color:white;font-size:16px" >注册</Button>
            </router-link>
          </Col>
        </FormItem>
      </Form>
    </div>
   </Col>
   </Row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import md5 from "js-md5";
export default {
  data() {
    return {
      mobile: "",
      pwd: "",
      rememberPwd: false
    };
  },
  mounted() {},
  methods: {
    login() {
      this.loading = true;
      let loginParams = {
        username: this.mobile,
        pwd:md5(this.mobile+this.pwd)
        // pwd: this.pwd//md5(this.pwd + this.mobile)
      };
      protocol.param_login.data =loginParams;
      http.post(protocol.param_login).then(response => {
        if (response.data.code == 0) {
          let sessionInfo = {}
          sessionInfo.mobile = this.mobile
          sessionInfo.pwd = md5(this.pwd + this.mobile)
          sessionInfo.token = response.data.token
          sessionInfo.userModel = JSON.stringify(response.data.user)
          sessionInfo.ResultModel = JSON.stringify(response.data.router)
          sessionInfo.isLogin = "login"
          this.$store.commit('setSessionInfo', sessionInfo)
          // 当记住密码的checbox选中时，像localStorage里存入一下用户输入的用户名和密码
          if (this.rememberPwd == true) {
            this.setlocalStorage(sessionInfo);
          }
          //document.cookie="token="+response.data.token;
          //document.cookie="mobile="+this.mobile;

          this.setCookie("token", response.data.token, 0);
          this.setCookie("mobile", this.mobile, 0);
          this.$store.commit('LOGIN_IN', [response.data.user.userName,response.data.token]);
          localStorage.setItem("access-token", response.data.token);
          //this.$router.go(0)
          this.$router.push({ path: "/indexPage" });
          
        } else {
          //this.$message({ type: "warning", message: response.data.msg });
          alert(response.data.msg);
        }
      });
    },
    goFirst: function() {
     this.$router.push({path:'/enroll'});
    },
    //设置cookie
    setCookie: function(cname, cvalue, exhours){
       var str = cname + "=" + escape(cvalue);
       if(exhours > 0){
          var d = new Date();
          d.setTime(d.getTime() + (exhours * 60 * 60 * 1000));
          //var expires = "expires=" + d.toUTCString();
          str += "; expires=" + d.toGMTString();
        }

        document.cookie = str+";domain=.jinmajia.com;path=/;";
        console.info(str);
    },
    //向localStorage里存入从页面获取的用户名和密码；
    setlocalStorage(info) {
      localStorage.jmjInfo = JSON.stringify(info)
    }
  }
};
</script>

<style scoped>
.enroll {
    
    margin:150px auto;
  background: whitesmoke;
  width: 600px;
  height: 300px;
  opacity: 0.9;
  
}
.bimg {
 border-bottom:1px solid black;
  opacity: 0.9;
  background-size: cover;
  background-image: url("../../../static/officeImg/index/connectBac1.png");
  
  height: 700px;
  margin:0 auto;
  width: 100%;
}
a{
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue